import 'babel-polyfill';
import './App.css';

import App from './app';
import { BASE_HREF } from './constants';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import React from 'react';
import { configureStore } from './reducers';
import { render } from 'react-dom';

const store = configureStore();
render(
  <Provider store={store}>
    <BrowserRouter basename={BASE_HREF}>
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById(`root`),
);



// WEBPACK FOOTER //
// ./src/index.js